import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { LabelEditor, useEditorStore } from '@/features/label-editor';
import type { ILabelDocument } from '@/features/label-editor/domain/types';
import {
  fetchModeloEtiqueta,
  labelTemplateKeys,
  updateModeloEtiqueta,
} from '@/services/labelTemplateService';
import './modelos-etiqueta.css';

export const Route = createFileRoute('/_authenticated/configuracao/modelos-etiqueta/form/$id')({
  component: EditarModeloEtiquetaPage,
});

function EditarModeloEtiquetaPage() {
  const { id } = Route.useParams();
  const queryClient = useQueryClient();
  const markClean = useEditorStore((s) => s.markClean);

  const { data, isLoading, isError } = useQuery({
    queryKey: labelTemplateKeys.detail(id),
    queryFn: () => fetchModeloEtiqueta(id),
  });

  const mutation = useMutation({
    mutationFn: (doc: ILabelDocument) =>
      updateModeloEtiqueta(id, {
        nome: doc.name,
        largura_mm: doc.width_mm,
        altura_mm: doc.height_mm,
        dpi: doc.dpi,
        documento: doc,
      }),
    onSuccess: async () => {
      markClean();
      await queryClient.invalidateQueries({ queryKey: labelTemplateKeys.all });
    },
  });

  if (isLoading) return <p>Carregando modelo…</p>;
  if (isError || !data) {
    return (
      <div>
        <p className="modelos-etiqueta-page__error">Modelo não encontrado.</p>
        <Link
          to="/configuracao/modelos-etiqueta"
          className="modelos-etiqueta-page__back"
        >
          Voltar
        </Link>
      </div>
    );
  }

  return (
    <div className="modelos-etiqueta-page modelos-etiqueta-page--editor">
      <div className="modelos-etiqueta-page__header">
        <h2>Editar: {data.nome}</h2>
        <Link
          to="/configuracao/modelos-etiqueta"
          className="modelos-etiqueta-page__back"
        >
          Voltar à lista
        </Link>
      </div>
      <LabelEditor
        initialDocument={data.documento}
        saving={mutation.isPending}
        onSave={(doc) => mutation.mutateAsync(doc)}
      />
      {mutation.isSuccess && (
        <p className="modelos-etiqueta-page__ok">Modelo salvo.</p>
      )}
      {mutation.isError && (
        <p className="modelos-etiqueta-page__error">Falha ao salvar modelo.</p>
      )}
    </div>
  );
}
